export default class Storage {
  handlers = [];

  // Re-rendering sections (variant/flavor swaps) keeps creating fresh handlers
  // without tearing down the old ones — without pruning, every state change
  // fans out across hundreds of dead listeners and starves the main thread.
  subscribe = (handler) => {
    this.handlers = this.handlers.filter((h) => {
      if (h.container && !document.contains(h.container)) return false;
      if (h.constructor === handler.constructor && h.container === handler.container) return false;
      return true;
    });
    this.handlers.push(handler);
  };

  setState = (state) => {
    this.state = state;
    this.handlers = this.handlers.filter((h) => !h.container || document.contains(h.container));
    this.handlers.forEach((handler) => handler.handle(state));
  };

  getState = () => this.state;
}
